import React from 'react'
import styled from 'styled-components'
import TreeSelect from 'components/TreeSelect'
import { Col, Row } from 'antd'
import FormItem from 'antd/es/form/FormItem'

const FilterLabel = styled.p`
  color: #000000;
  font-size: 14px;
  font-weight: 600;
  white-space: ${props => (props.whiteSpace ? props.whiteSpace : '')};
`
export const BoldText = styled.p`
  font-weight: bold;
  width: max-content;
  margin-top: 5px;
`

const DegreeDepartmentFilter = ({
  state,
  handleDegreeChange,
  handleDepartmentChange,
  handleSpecialisationChange,
  handleDegreeSearch,
  handleDepartSearch,
}) => {
  return (
    <>
    <Row style={{ margin: '0px', rowGap: '0px !important' }}>
      <Col
       span={23}
        style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
      >
        <FilterLabel>Degree</FilterLabel>
        <FormItem style={{ width: '100%' }} className="tree-select-degree">
          <TreeSelect
            showArrow={true}
            filterTreeNode={false}
            treeCheckable={true}
            placeholder="Select Degree"
            maxTagCount={0}
            showSearch={true}
            treeDefaultExpandAll={true}
            removeTreeIndent={true}
            shadowBox
            onChange={handleDegreeChange}
            treeData={state.degreeList || []}
            onSearch={data => handleDegreeSearch(data)}
            value={state.degreeValue || []}
            height={'auto'}
            treeNodeFilterProp="title"
            autoClearSearchValue={false}
          />
        </FormItem>
      </Col>
      <Col
       span={23}
        style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
      >
        <FilterLabel>Depart.</FilterLabel>
        <FormItem style={{ width: '100%' }} className="tree-select-degree">
          <TreeSelect
            showArrow={true}
            filterTreeNode={false}
            treeCheckable={true}
            placeholder="Select Department"
            maxTagCount={0}
            showSearch={true}
            treeDefaultExpandAll={true}
            removeTreeIndent={true}
            shadowBox
            treeData={state.departList || []}
            disabled={state.selectedCourse.length === 0}
            onChange={handleDepartmentChange}
           // onSearch={data => handleDepartSearch(data)}
            value={state.departValue || []}
            height={'auto'}
            treeNodeFilterProp="title"
            autoClearSearchValue={false}
          />
        </FormItem>
      </Col>
     <Col
      span={23}
       style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
     >
       <FilterLabel>Spec.</FilterLabel>
       <FormItem style={{ width: '100%' }} className="tree-select-degree">
         <TreeSelect
           showArrow={true}
           filterTreeNode={false}
           treeCheckable={true}
           placeholder="Select Specialization"
           maxTagCount={0}
           showSearch={true}
           treeDefaultExpandAll={true}
           removeTreeIndent={true}
           shadowBox
           onChange={handleSpecialisationChange}
           treeData={state.splList || []}
         //  onSearch={data => handleDegreeSearch(data)}
           value={state.splValue || []}
           height={'auto'}
           treeNodeFilterProp="title"
           autoClearSearchValue={false}
           disabled={state.selectedDepartCourse.length === 0}
         />
       </FormItem>
     </Col> 
     
    </Row>
  
   </>
  )
}

export default DegreeDepartmentFilter
